/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
    "/v2/locations/{locationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationsController_getLocation_v2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/locations/{locationId}/engagements/{engagementId}/recordings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationEngagementsV2Controller_getRecordings_v2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/locations/{locationId}/engagements/{engagementId}/recordings/cameras/{cameraId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LocationEngagementsV2Controller_getCameraRecordings_v2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
};
export type webhooks = Record<string, never>;
export type components = {
    schemas: {
        LocationUser: {
            userId: string;
            emailAddress?: string;
        };
        SubscriptionPlan: {
            name: string;
            sku: string;
        };
        LocationFeatureConsent: {
            /** Format: date-time */
            acceptedAt?: string;
            acceptedBy?: string;
        };
        LocationFeature: {
            name: string;
            enabled: boolean;
            options?: Record<string, unknown>;
            consent?: components["schemas"]["LocationFeatureConsent"];
        };
        LocationPermitStatus: {
            hasAddressChanged?: boolean;
            hasSubscriptionReactivated?: boolean;
            hasLocationTypeChanged?: boolean;
            hasJurisdictionChanged?: boolean;
            haveAgencyRulesChanged?: boolean;
            hasJurisdictionPolicyChanged?: boolean;
            hasLocationOwnershipChanged?: boolean;
        };
        LocationPermit: {
            source: string;
            status?: components["schemas"]["LocationPermitStatus"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string;
            /** Format: date-time */
            updatedAt: string;
            updatedBy: string;
            permitNumber?: string;
            isNotNumbered?: boolean;
            /** Format: date */
            expirationDate?: string;
            isEternal?: boolean;
        };
        LocationPermits: {
            police?: components["schemas"]["LocationPermit"];
            fire?: components["schemas"]["LocationPermit"];
            medical?: components["schemas"]["LocationPermit"];
        };
        LocationAddress: {
            street1?: string;
            street2?: string;
            crossStreet?: string;
            city?: string;
            state?: string;
            zip?: string;
            county?: string;
            country?: string;
            /** @enum {string} */
            propertyType?: LocationAddressPropertyType;
            /**
             * @deprecated
             * @enum {number}
             */
            residenceType?: LocationAddressResidenceType;
            /** @enum {string} */
            timeZone?: LocationAddressTimeZone;
        };
        PolicyRenewalDto: {
            isSimpliSafeManaged: boolean;
        };
        PolicyRegistrationDto: {
            isSimpliSafeManaged: boolean;
        };
        GuardPolicyDto: {
            /** @enum {string} */
            status: GuardPolicyDtoStatus;
        };
        PolicyDto: {
            renewal: components["schemas"]["PolicyRenewalDto"];
            registration: components["schemas"]["PolicyRegistrationDto"];
            guard?: components["schemas"]["GuardPolicyDto"];
        };
        CodeWithDescriptionDto: {
            code: string;
            description?: string;
        };
        RawCodeWithDescriptionDto: {
            raw: components["schemas"]["CodeWithDescriptionDto"];
        };
        PermitRequirementDto: {
            /** @enum {string} */
            requirement: PermitRequirementDtoRequirement;
        };
        PermitRequirementsDto: {
            raw: components["schemas"]["CodeWithDescriptionDto"];
            commercial?: components["schemas"]["PermitRequirementDto"];
            residential?: components["schemas"]["PermitRequirementDto"];
        };
        PermitRenewalDto: {
            isRequired: boolean;
            /** @enum {string} */
            cadence?: PermitRenewalDtoCadence;
        };
        EnhancedCallVerificationRequirementsDto: {
            raw: components["schemas"]["CodeWithDescriptionDto"];
            count: number;
        };
        RawFalseAlarmRuleDto: {
            limit?: string;
            period?: string;
        };
        FalseAlarmRuleDto: {
            raw?: components["schemas"]["RawFalseAlarmRuleDto"];
        };
        FalseAlarmRulesDto: {
            fineable?: components["schemas"]["FalseAlarmRuleDto"];
            suspendable?: components["schemas"]["FalseAlarmRuleDto"];
        };
        AgencyJurisdictionalRulesDto: {
            permitResponsible: components["schemas"]["RawCodeWithDescriptionDto"];
            renewalResponsible: components["schemas"]["RawCodeWithDescriptionDto"];
            permitRequirements: components["schemas"]["PermitRequirementsDto"];
            permitOrdinanceUrl?: string;
            permitRegistrationUrl?: string;
            permitRenewal?: components["schemas"]["PermitRenewalDto"];
            isPrivateResponseRequired?: boolean;
            verifiedResponseRequirements?: components["schemas"]["RawCodeWithDescriptionDto"];
            enhancedCallVerificationRequirements?: components["schemas"]["EnhancedCallVerificationRequirementsDto"];
            multipleAlarmTriggersRequirements?: components["schemas"]["RawCodeWithDescriptionDto"];
            permitAdditionalNotes?: string;
            /** Format: date-time */
            lastResearchedDate?: string;
            falseAlarmRules?: components["schemas"]["FalseAlarmRulesDto"];
        };
        AgencyRulesMapDto: {
            fire?: components["schemas"]["AgencyJurisdictionalRulesDto"];
            police?: components["schemas"]["AgencyJurisdictionalRulesDto"];
        };
        JurisdictionDto: {
            id: string;
            name: string;
            policies: components["schemas"]["PolicyDto"];
            agencyRules: components["schemas"]["AgencyRulesMapDto"];
        };
        PrimaryContactName: {
            firstName: string;
            lastName: string;
        };
        Phone: {
            number: string;
        };
        PrimaryContact: {
            name?: components["schemas"]["PrimaryContactName"];
            phone: components["schemas"]["Phone"];
        };
        SecondaryContact: {
            name: string;
            phone: components["schemas"]["Phone"];
        };
        Contacts: {
            primaryContacts: components["schemas"]["PrimaryContact"][];
            secondaryContacts: components["schemas"]["SecondaryContact"][];
        };
        ServiceStatusSetting: {
            isEnabled: boolean;
            /** Format: date-time */
            startTimestamp?: string;
            /** Format: date-time */
            endTimestamp?: string;
        };
        Interval: {
            offset: string;
            duration: string;
        };
        OutdoorMonitoring: {
            hasEligiblePlan: boolean;
            activeDailyIntervals?: components["schemas"]["Interval"][];
            isActive: boolean;
        };
        ServiceStatus: {
            professionalMonitoring: components["schemas"]["ServiceStatusSetting"];
            practiceMode: components["schemas"]["ServiceStatusSetting"];
            noAction?: components["schemas"]["ServiceStatusSetting"];
            outdoorMonitoring?: components["schemas"]["OutdoorMonitoring"];
        };
        LocationMonitoring: {
            /** @enum {string} */
            monitoringServiceProviderId: LocationMonitoringMonitoringServiceProviderId;
            serviceStatus: components["schemas"]["ServiceStatus"];
        };
        Location: {
            id: string;
            user: components["schemas"]["LocationUser"];
            plan: components["schemas"]["SubscriptionPlan"];
            features?: components["schemas"]["LocationFeature"][];
            name: string;
            permits?: components["schemas"]["LocationPermits"];
            baseStationSerialNumber?: string;
            address?: components["schemas"]["LocationAddress"];
            jurisdiction?: components["schemas"]["JurisdictionDto"];
            contacts?: components["schemas"]["Contacts"];
            monitoring?: components["schemas"]["LocationMonitoring"];
            templateId?: string;
            dispatchNotes?: string;
        };
        EngagementRecordings: {
            accessAllowed: boolean;
            /** @enum {string} */
            disallowedReason?: EngagementRecordingsDisallowedReason;
            recordings?: {
                [key: string]: components["schemas"]["EngagementCameraRecording"];
            };
        };
        VideoClipLink: {
            href?: string;
            method?: string;
            templated?: boolean;
        };
        VideoClipLinks: {
            "playback/dash": components["schemas"]["VideoClipLink"];
            "playback/flv": components["schemas"]["VideoClipLink"];
            "playback/hls": components["schemas"]["VideoClipLink"];
        };
        EngagementVideo: {
            /** Format: date-time */
            startTime: string;
            /** Format: date-time */
            endTime: string;
            /** Format: date-time */
            agentViewStart?: string;
            links: components["schemas"]["VideoClipLinks"];
        };
        EngagementCameraRecording: {
            cameraId: string;
            accessAllowed: boolean;
            /** @enum {string} */
            disallowedReason?: EngagementRecordingsDisallowedReason;
            videos?: components["schemas"]["EngagementVideo"][];
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
};
export type $defs = Record<string, never>;
export interface operations {
    LocationsController_getLocation_v2: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Location"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationEngagementsV2Controller_getRecordings_v2: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                locationId: string;
                engagementId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngagementRecordings"];
                };
            };
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LocationEngagementsV2Controller_getCameraRecordings_v2: {
        parameters: {
            query: {
                start: string;
                end: string;
            };
            header?: never;
            path: {
                locationId: string;
                engagementId: string;
                cameraId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EngagementCameraRecording"];
                };
            };
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
}
export enum LocationAddressPropertyType {
    Apartment = "Apartment",
    House = "House",
    Commercial = "Commercial"
}
export enum LocationAddressResidenceType {
    Value0 = 0,
    Value1 = 1,
    Value2 = 2,
    Value3 = 3
}
export enum LocationAddressTimeZone {
    America_New_York = "America/New_York",
    America_Chicago = "America/Chicago",
    America_Denver = "America/Denver",
    America_Los_Angeles = "America/Los_Angeles",
    America_Puerto_Rico = "America/Puerto_Rico",
    America_Phoenix = "America/Phoenix",
    Pacific_Honolulu = "Pacific/Honolulu",
    America_Anchorage = "America/Anchorage",
    Europe_London = "Europe/London",
    Pacific_Guam = "Pacific/Guam",
    Unknown = "Unknown",
    Unresolved = "Unresolved"
}
export enum GuardPolicyDtoStatus {
    GuardAutoEnrolled = "GuardAutoEnrolled",
    GuardRecommended = "GuardRecommended",
    None = "None"
}
export enum PermitRequirementDtoRequirement {
    Required = "Required",
    Recommended = "Recommended",
    RequiredAfterFalseAlarmLimit = "RequiredAfterFalseAlarmLimit",
    NotRequired = "NotRequired",
    Unknown = "Unknown"
}
export enum PermitRenewalDtoCadence {
    NONE = "NONE",
    ANN = "ANN",
    Quarterly = "Quarterly",
    Odd_Years = "Odd Years",
    Even_Years = "Even Years",
    FAlimit = "FAlimit",
    JAN = "JAN",
    FEB = "FEB",
    MAR = "MAR",
    APR = "APR",
    MAY = "MAY",
    JUN = "JUN",
    JUL = "JUL",
    AUG = "AUG",
    SEP = "SEP",
    OCT = "OCT",
    NOV = "NOV",
    DEC = "DEC",
    Unknown = "Unknown"
}
export enum LocationMonitoringMonitoringServiceProviderId {
    rrms_wholesale = "rrms-wholesale",
    rrms_internal = "rrms-internal",
    securitas = "securitas",
    self_monitored = "self-monitored"
}
export enum EngagementRecordingsDisallowedReason {
    UserNotAllowedRecordingAccess = "UserNotAllowedRecordingAccess",
    CustomerOptedOutOfQualityAssurance = "CustomerOptedOutOfQualityAssurance",
    CustomerDeletedRecording = "CustomerDeletedRecording"
}
